import React from 'react';
import { BrowserRouter } from "react-router-dom";
import './resources/sass/main.scss';
import Routes from "./Routes";
import CacheBuster from './CacheBuster';

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        );
      }}
    </CacheBuster>
  );
}

export default App;
